
<div class="row">
  <div [ngClass]="{ 'col-xl-7 col-lg-12': checkoutMode, 'col-xl-12 col-lg-12' : !checkoutMode }">

    <div class="input-group" [ngClass]="{ 'input-group-right-aligned': viewType === 'list' }">
      <div class="input-group-prepend">
        <button class="quantity-update quantity-minus" (click)="minus()" tabindex="-1"><i class="fa fa-minus"></i></button>
      </div>

      <input type="number" min="1" class="form-control" [formControl]="quantityInput" (keyup.enter)="addToCart()">

      <div class="input-group-append">
        <button class="quantity-update quantity-plus" (click)="plus()" tabindex="-1"><i class="fa fa-plus"></i></button>
      </div>

      <!--
      <div class="input-group-append actual-quantity d-none d-xl-block" *ngIf="checkoutMode">
        <span class="number">{{ unit }}</span>
        <span class="unit">{{ 'order.order-unit' | translate }}</span>
      </div>
    -->

      <div class="input-group-append actual-quantity" *ngIf="showAbsoluteQuantity">
        <span class="number">{{ absoluteQuantity }}</span>
        <span class="unit">{{ 'order.pieces-abbrev' | translate }}</span>
      </div>

      <button class="btn btn-success" [ngClass]="{ 'margin-left': !showAbsoluteQuantity }" *ngIf="!checkoutMode" (click)="addToCart()" tabindex="-1">
        <i class="fa fa-cart-arrow-down"></i>
      </button>
    </div>

  </div>
  <div class="d-none d-xl-block col-xl-3 text-center" *ngIf="checkoutMode && quantityType === 'relative'">
      {{ unit }}
  </div>
  <div class="d-none d-xl-block col-xl-2 text-right" *ngIf="checkoutMode && quantityType === 'relative'">
      {{ absoluteQuantity }}
  </div>
</div>
